<template>
  <div class="intro-header">
    <img class="main-image-top" src="./img/pitch.svg" alt="pitch" />

    <!-- User photo and main header -->

    <h2>
      <TenantLogo v-if="sectionSelected === 'Player Profile'" logo-class="login-logo" id="small_shirt" />
      {{ sectionSelected }}
    </h2>

    <div v-if="$route.name !== 'ptHome' && $route.name !== 'ptUserHome'" class="user-photo-info">
      <template v-if="
        selectedUserData !== null &&
        selectedUserData !== undefined &&
        Object.keys(selectedUserData).length !== 0
      ">
        <img v-if="
          selectedUserData.userImage !== '' &&
          selectedUserData.userImage !== null
        " id="user_photo" :src="getImgUrl(selectedUserData.userImage)" alt="" />
        <TenantLogo v-else logo-class="login-logo" id="user_photo" />
      </template>
      <template v-else>
        <img v-if="
          userDataForHeader.userImage !== '' &&
          userDataForHeader.userImage !== null
        " id="user_photo" :src="getImgUrl(userDataForHeader.userImage)" alt="" />
        <TenantLogo v-else logo-class="login-logo" id="user_photo" />
      </template>

      <template v-if="
        selectedUserData !== null &&
        selectedUserData !== undefined &&
        Object.keys(selectedUserData).length !== 0
      ">
        <h1 v-if="selectedUserData.userType === 'User'">
          {{ selectedUserData.name }}
        </h1>
      </template>
      <template v-else>
        <h1>{{ userDataForHeader.name }}</h1>
      </template>
    </div>

    <div v-if="$route.name !== 'ptHome' && $route.name !== 'ptUserHome'" class="sessons-header">
      <PhasePill
        v-if="getProfile && getProfile.clubId"
        :club-id="getProfile.clubId"
        :team-id="userDataForHeader && userDataForHeader.teamId ? userDataForHeader.teamId : null"
        class="header-phase-pill"
      />
      <div class="form">
        <div class="form__item">
          <div v-if="
            (userDataForHeader.userType === 'Admin' ||
              userDataForHeader.userType === 'Coach') &&
            $route.name !== 'home' &&
            $route.name !== 'profile' &&
            $route.name !== 'ptHome' &&
            $route.name !== 'coaches' &&
            $route.name !== 'documents'
          " class="select-user">
            <label class="form__label" for="userSelect">Change user</label>
            <select @change="setSelectedUserOfTrainingPlan($event)" id="userSelect">
              <option value="" disabled selected>Select user</option>
              <option :value="user.id" v-for="user in coachesUsersData" :key="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>

          <div v-if="
            (userDataForHeader.userType === 'Admin' ||
              userDataForHeader.userType === 'Coach') &&
            $route.name !== 'home' &&
            $route.name === 'profile' &&
            $route.name !== 'coaches' &&
            $route.name !== 'documents' &&
            $route.name !== 'ptHome'
          " class="select-user">
            <!--<b-input-group size="sm" class="mb-2 autocomplete">
              <b-input-group-prepend is-text>
                <i class="bi bi-search"></i>
              </b-input-group-prepend>
              <b-form-input
                type="search"
                placeholder="Search players"
                @input="lookUpSearch($event)"
              ></b-form-input>
              <ul
                class="autocomplete-results"
                v-if="filterdCoachesUsersData.length > 0"
              >
                <li
                  @click="setSelectedUserOfTrainingPlan(userData)"
                  v-for="userData in filterdCoachesUsersData"
                  :key="userData.id"
                  class="autocomplete-result"
                >
                  {{ userData.name }}
                </li>
              </ul>
            </b-input-group>-->
          </div>

          <!-- training plan look up -->

          <!--<div
            v-if="
              (userDataForHeader.userType === 'Admin' ||
                userDataForHeader.userType === 'Coach') &&
              $route.name !== 'ptHome'
            "
            class="select-user"
          >
            <b-input-group size="sm" class="mb-2 autocomplete">
              <b-input-group-prepend is-text>
                <i class="bi bi-search"></i>
              </b-input-group-prepend>
              <b-form-input
                type="search"
                placeholder="Search players"
                @input="lookUpSearch($event)"
              ></b-form-input>
              <ul
                class="autocomplete-results"
                v-if="filterdCoachesUsersData.length > 0"
              >
                <li
                  @click="openTrainingPlanPageCall(userData.id)"
                  v-for="userData in filterdCoachesUsersData"
                  :key="userData.id"
                  class="autocomplete-result"
                >
                  {{ userData.name }}
                </li>
              </ul>
            </b-input-group>
          </div>-->

          <!-- coach look up -->

          <div v-if="
            (userDataForHeader.userType === 'Admin' ||
              userDataForHeader.userType === 'Coach') &&
            $route.name === 'coaches'
          " class="select-user">
            <h1>Coaches</h1>
            <b-input-group size="sm" class="mb-2 autocomplete">
              <i class="bi bi-search"></i>
              <b-form-input type="search" placeholder="Search coaches"
                @update:modelValue="lookUpSearch($event)"></b-form-input>
              <ul class="autocomplete-results" v-if="filterdCoachesData.length > 0">
                <li @click="openTrainingPlanPageCall(userData.id)" v-for="userData in filterdCoachesData"
                  :key="userData.id" class="autocomplete-result">
                  {{ userData.name }}
                </li>
              </ul>
            </b-input-group>
          </div>

          <div class="select-user" v-if="
            (userDataForHeader.userType === 'Admin' ||
              userDataForHeader.userType === 'Coach') &&
            $route.name === 'documents'
          ">
            <h1>Documents library</h1>
          </div>
        </div>
      </div>

      <h2 v-if="userDataForHeader.userType === 'User'">
        <div v-if="sectionSelected === 'Player Profile'" class="player-profile-header">
          <p><span>Dob:</span> {{ dayMonthYear(userDataForHeader.dob) }}</p>
          <p><span>Position:</span> {{ userDataForHeader.position }}</p>
          <p><span>Team:</span> {{ userDataForHeader.teamName }}</p>
          <p v-for="team in playersOtherTeamsData" :key="team.id" class="playing-extra-team">
            <span>{{ playingLevel(team) }}:</span> {{ team.teamName }}
          </p>
          <p v-if="checkSignedDate(userDataForHeader.joined_date)">
            <span>Signed:</span>
            {{ dayMonthYear(userDataForHeader.joined_date) }}
          </p>

          <p v-if="pathWayCheck(userDataForHeader.age_group) === 'Foundation'">
            <span>Phase:</span>
            {{ pathWayCheck(userDataForHeader.age_group) }}
          </p>
          <p v-if="
            pathWayCheck(userDataForHeader.age_group) === 'Youth Development'
          ">
            <span>Phase:</span>
            {{ pathWayCheck(userDataForHeader.age_group) }}
          </p>
          <p v-if="
            pathWayCheck(userDataForHeader.age_group) ===
            'Professional Development'
          ">
            <span>Phase:</span>
            {{ pathWayCheck(userDataForHeader.age_group) }}
          </p>
        </div>
      </h2>
      <div v-else class="header-buttons">
        <span v-if="
          $route.name !== 'home' &&
          $route.name !== 'ptHome' &&
          $route.name !== 'coaches' &&
          $route.name !== 'documents' &&
          selectedTrainingUserData
        " class="week-selected-dates-text">
          <p><span>Position:</span> {{ selectedTrainingUserData.position }}</p>
          <p>
            <span>Dob:</span> {{ dayMonthYear(selectedTrainingUserData.dob) }}
          </p>
          <p><span>Team:</span> {{ selectedUserData?.teamName }}</p>
          <p v-for="team in playersOtherTeamsData" :key="team.id" class="playing-extra-team">
            <span>{{ playingLevel(team) }}:</span> {{ team.teamName }}
            <a v-if="canManageTeams" class="remove-extra-team" href="javascript:;"
              @click="removeExtraTeam(team.id)" title="Remove from team">&times;</a>
          </p>
          <p v-if="canManageTeams" class="add-extra-team">
            <a v-if="!showAddExtraTeam" href="javascript:;" @click="openAddExtraTeam">+ Add another team</a>
            <select v-else v-model="selectedExtraTeamId" @change="addExtraTeam">
              <option disabled value="">Select team…</option>
              <option v-for="t in addableTeams" :value="t.id" :key="t.id">{{ t.teamName }}</option>
            </select>
          </p>
          <p v-if="checkSignedDate(selectedTrainingUserData.joined_date)">
            <span>Signed:</span>
            {{ dayMonthYear(selectedTrainingUserData.joined_date) }}
          </p>
        </span>
      </div>
    </div>
    <div class="playerPerformaceScoreWrapper" v-if="
      $route.name !== 'ptHome' &&
      $route.name !== 'ptUserHome' &&
      $route.name !== 'trainingPlans' &&
      userDataForHeader.userType !== 'Admin' &&
      userDataForHeader.userType !== 'Coach'
    ">
      <!--<CircularPercentage
      v-if="allplayerPerformanceReportData.length > 0"
        :review="null"
        :allPlayerReviews="allplayerPerformanceReportData"
        circularType="muilti"
      />-->
    </div>
  </div>
</template>

<script>
import { isCalendarSeason } from "@/config/tenant";
import { mapGetters } from "vuex";
import {
  POPULATE_WEEK_SELECTED_NUMBER,
  POPULATE_SELECTED_CALENDAR_DATE,
  POPULATE_MON_TO_FRI_DATE,
  POPULATE_COACHES_USER_DATA,
} from "@/store/actions/user.js";
import { PerformanceReview } from "@/services/performance-review-service.js";
import { Teams } from "@/services/teams-service.js";
import { Users } from "@/services/user-service.js";
// import CircularPercentage from "../../components/CircularPercentage";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import TenantLogo from "@/components/TenantLogo/index.vue";
import PhasePill from "@/components/PhasePill/index.vue";
import moment from "moment";
export default {
  mixins: [extendSeasonEndDateToFullYearMixin],
  components: {
    TenantLogo,
    PhasePill,
  },
  data() {
    return {
      weeklyDate: "",
      weekSelectedNumber: "",
      sectionSelected: "",
      selectedTrainingUserData: null,
      selectedWeekMonSunday: "",
      userData: null,
      filterdCoachesUsersData: [],
      filterdCoachesData: [],
      currentPlayingSeason: null,
      allplayerPerformanceReportData: [],
      playerPerformanceReportDataSummary: {
        attitude: "4",
        leadership: "3",
        mentality: "2",
        physique: "4",
        professionalism: "3",
        skill: "2",
      },
      playerPerformanceReportDataSummaryArrays: {
        attitude: [],
        skill: [],
        physique: [],
        mentality: [],
        leadership: [],
        professionalism: [],
      },
      selectedUserTeamData: null,
      season_start_date: null,
      season_end_date: null,
      showPlayerPerformaceReviewAvrageScore: false,
      // Playing up/down: the player's extra (secondary) teams.
      playersOtherTeamsData: [],
      clubTeams: [],
      showAddExtraTeam: false,
      selectedExtraTeamId: "",
      lastLoadedTeamsPlayerId: null,
    };
  },
  props: {
    userDataForHeader: {
      type: Object,
    },
    coachesUsersData: {
      type: Array,
    },
    selectedUserData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      "getWeekNumber",
      "getProfile",
      "getSelectedCalendarDateValue",
    ]),

    // The player being shown (viewed player if present, else the header user).
    subjectPlayer() {
      return this.selectedUserData && this.selectedUserData.id
        ? this.selectedUserData
        : this.userDataForHeader || {};
    },

    // Only coaches/admins can add or remove a player's extra teams.
    canManageTeams() {
      const me = this.getProfile || {};
      return (
        me.userType === "Admin" ||
        me.userType === "Coach" ||
        me.position === "Coach" ||
        me.position === "HeadCoach"
      );
    },

    // Club teams not already the player's primary or an existing extra team.
    addableTeams() {
      const primary = Number(this.subjectPlayer.teamId);
      const taken = new Set(
        this.playersOtherTeamsData.map((t) => Number(t.id))
      );
      return (this.clubTeams || []).filter(
        (t) => Number(t.id) !== primary && !taken.has(Number(t.id))
      );
    },
  },
  watch: {
    selectedUserData: {
      immediate: true,
      deep: true,
      handler: function (newValue) {
        this.getPlayerPerformanceReviews(this.userDataForHeader.id);
        if (newValue !== null) {
          this.selectedTrainingUserData = newValue;
        }
        this.maybeLoadOtherTeams();
      },
    },
    userDataForHeader: {
      immediate: true,
      deep: true,
      handler: function () {
        if (this.userDataForHeader.userType === "User") {
          this.getPlayerPerformanceReviews(this.userDataForHeader.id);
          this.showPlayerPerformaceReviewAvrageScore = true;
        }
        this.maybeLoadOtherTeams();
      },
    },
  },
  created() {
    this.weekSelectedNumber = moment().isoWeek();
    this.setPlayingSeasion();
    this.setMonToSundayWeekDates();

    this.setSection(this.$route.name);
    // this.checkIfWeekNumberHasBeenSet();
    this.setUser();
    if (this.$route.params.trainingPlanUserId !== 0) {
      this.coachesUsersData.length > 0
        ? this.setSelectedTrainingPlanUser(
          this.$route.params.trainingPlanUserId,
        )
        : this.setCoachesUsersData(this.$route.params.trainingPlanUserId);
    }
  },
  methods: {
    // ---- Playing up/down: extra teams ----------------------------------
    maybeLoadOtherTeams() {
      const id = this.subjectPlayer && this.subjectPlayer.id;
      if (!id || id === this.lastLoadedTeamsPlayerId) return;
      this.lastLoadedTeamsPlayerId = id;
      this.showAddExtraTeam = false;
      this.selectedExtraTeamId = "";
      this.loadOtherTeams();
    },

    async loadOtherTeams() {
      const player = this.subjectPlayer;
      if (!player || !player.id) {
        this.playersOtherTeamsData = [];
        return;
      }
      try {
        const res = await Teams.find({
          action: "getPlayersOtherTeams",
          user_id: player.id,
          defaultTeamId: player.teamId,
        });
        this.playersOtherTeamsData = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.playersOtherTeamsData = [];
      }
    },

    async loadClubTeams() {
      const me = this.getProfile || {};
      try {
        const payload =
          me.userType === "Coach"
            ? { action: "getTeamsByCoachid", coach_id: me.id }
            : { action: "populateTeamData", clubId: me.clubId };
        const res = await Teams.find(payload);
        this.clubTeams = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.clubTeams = [];
      }
    },

    // age_group is a birth YEAR: a LOWER year = older players = playing up.
    playingLevel(team) {
      const playerYear = parseInt(this.subjectPlayer.age_group, 10);
      const teamYear = parseInt(team && team.age_group, 10);
      if (isNaN(playerYear) || isNaN(teamYear)) return "Also playing";
      if (teamYear < playerYear) return "Playing up";
      if (teamYear > playerYear) return "Playing down";
      return "Also playing";
    },

    openAddExtraTeam() {
      this.showAddExtraTeam = true;
      if (!this.clubTeams.length) this.loadClubTeams();
    },

    async addExtraTeam() {
      if (!this.selectedExtraTeamId || !this.subjectPlayer.id) return;
      try {
        await Users.find({
          action: "addPlayerToNewTeam",
          user_id: this.subjectPlayer.id,
          teamId: this.selectedExtraTeamId,
        });
        if (this.$toast) this.$toast.success("Player added to team");
      } catch (e) {
        // ignore
      }
      this.selectedExtraTeamId = "";
      this.showAddExtraTeam = false;
      this.loadOtherTeams();
    },

    async removeExtraTeam(teamId) {
      if (!this.subjectPlayer.id) return;
      try {
        await Teams.find({
          action: "removePlayerFromTeam",
          user_id: this.subjectPlayer.id,
          teamId,
        });
        if (this.$toast) this.$toast.success("Player removed from team");
      } catch (e) {
        // ignore
      }
      this.loadOtherTeams();
    },

    currentPlayingseasonStartDate() {
      return localStorage.getItem("currentPlayingseasonStartDate");
    },
    currentPlayingseasonEndDate() {
      return localStorage.getItem("currentPlayingseasonEndDate");
    },
    async getPlayerPerformanceReviews() {
      let userIdData =
        this.selectedUserData !== null &&
          this.selectedUserData !== undefined &&
          Object.keys(this.selectedUserData).length !== 0
          ? this.selectedUserData.id
          : this.userDataForHeader.id;

      const userData = {
        userId: userIdData,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getPerformanceReviews",
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.allplayerPerformanceReportData = responce.data;
      }
    },
    pathWayCheck(year) {
      const currentYear = moment().year();
      if (currentYear - year > 9 && currentYear - year < 11) {
        return "Foundation";
      }
      if (currentYear - year > 11 && currentYear - year < 16) {
        return "Youth Development";
      }
      if (currentYear - year > 16 && currentYear - year < 21) {
        return "Professional Development";
      }
    },
    checkSignedDate(date) {
      if (date === null || date === undefined) {
        return;
      } else {
        return date;
      }
    },
    openTrainingPlanPageCall(userId) {
      const data = [userId, "Admin", "Training Plan"];
      this.$emit("callToOpenTrainingPlan", { ...data });
    },
    setPlayingSeasion() {
      if (isCalendarSeason()) {
        // Calendar-year seasons (e.g. Australia, played Mar-Sep): the
        // playing season is simply the current year - the early-year
        // weeks belong to the SAME year's season, not the previous one.
        this.currentPlayingSeason = moment().format("YYYY");
        localStorage.setItem("currentPlayingSeason", this.currentPlayingSeason);
        return;
      }
      if (this.weekSelectedNumber >= 8 && this.weekSelectedNumber < 52) {
        this.currentPlayingSeason = moment().format("YYYY");
      }
      if (this.weekSelectedNumber >= 1 && this.weekSelectedNumber < 8) {
        this.currentPlayingSeason = moment().subtract(1, "year").format("YYYY");
      }
      if (this.weekSelectedNumber == 52) {
        moment().format("M") === "1"
          ? (this.currentPlayingSeason = moment()
            .subtract(1, "year")
            .format("YYYY"))
          : (this.currentPlayingSeason = moment().format("YYYY"));
      }

      localStorage.setItem("currentPlayingSeason", this.currentPlayingSeason);
    },
    lookUpSearch(value) {
      if (value.length > 3) {
        this.filterdCoachesUsersData = [];

        const results = Array.from(value).reduce(
          (a, v, i) => `${a}[^${value.substr(i)}]*?${v}`,
          "",
        );
        const regEx = RegExp(results);

        this.coachesUsersData.filter((v) => {
          if (v.name.match(regEx)) {
            this.filterdCoachesUsersData.push(v);
          }
        });
      } else {
        this.filterdCoachesUsersData = [];
      }
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    checkforDotAtTheStartOfUrl(p) {
      return p.startsWith(".") ? p.substring(1) : p;
    },
    checkTheimageForBlob(p, imageNumber) {
      if (p !== null) {
        var URL = this.checkforDotAtTheStartOfUrl(p);
      }
      switch (typeof URL) {
        case "string":
          URL.search("blob:") !== -1
            ? p
            : `${window.location.protocol}//${window.location.host}${URL}`;
          return URL.search("blob:") !== -1
            ? p
            : `${window.location.protocol}//${window.location.host}${URL}`;
        case "object":
          return this[imageNumber].path;
      }
    },
    getPath(p, imageNumber) {
      if (p === undefined) {
        return;
      }
      return this.checkTheimageForBlob(p, imageNumber);
    },
    setSelectedUserOfTrainingPlan(e) {
      let userId = null;
      this.filterdCoachesUsersData = [];
      e.target === undefined ? (userId = e) : (userId = e.target.value);

      this.coachesUsersData.length > 0
        ? this.setSelectedTrainingPlanUser(userId)
        : this.setCoachesUsersData(userId);
      // const selectedUser = e;
      this.$emit("selectedUseChanged", { ...e });
    },
    setSelectedTrainingPlanUser(id) {
      let arrayResult = this.coachesUsersData.filter((selectedTrainingUser) => {
        return selectedTrainingUser.id == id;
      });
      if (arrayResult.length !== 0) {
        this.selectedTrainingUserData = arrayResult[0];
      }
    },
    populateCalendarDateWithCurrentWeek() {
      this.weekSelectedNumber = moment().isoWeek();
      this.weeklyDate = moment().format("YYYY-MM-DD");
      this.despachTheCalendarActionSetLocalStorage();
      this.despachTheWeekActionSetLocalStorage();
    },
    setUser() {
      if (Object.keys(this.getProfile).length == 0) {
        this.userData = this.getProfile;
      }
    },
    setSection(sectionName) {
      switch (sectionName) {
        case "home":
          this.sectionSelected = "Dashboard";
          break;
        case "trainingPlans":
          this.sectionSelected =
            this.$route.params.trainingPlanType === "All"
              ? "Players training plans"
              : this.$route.params.trainingPlanType;
          break;
        case "ptUserHome":
          this.sectionSelected = "Training library";
          break;
        case "ptHome":
          this.sectionSelected = "Training library";
          break;
        case "profile":
          this.sectionSelected = "Player Profile";
          break;
      }
    },
    depatchMonToSundayWeekDatesInLocalStorage() {
      const monToFri = this.selectedWeekMonSunday;
      localStorage.setItem("mondaySunDates", this.selectedWeekMonSunday);
      this.$store.dispatch(
        POPULATE_MON_TO_FRI_DATE,
        this.selectedWeekMonSunday,
      );
      this.$emit("mondaySunDatesChanged", { monToFri });
    },
    setMonToSundayWeekDates() {
      const year = JSON.stringify(moment().year());
      const monday = moment()
        .year(year)
        .isoWeek(this.weekSelectedNumber)
        .day("monday")
        .startOf("day");
      this.selectedWeekMonSunday =
        monday.format("MMM D - ") + monday.add(6, "days").format("D YYYY");
      this.depatchMonToSundayWeekDatesInLocalStorage();
    },
    setCalendarDate() {
      const year = JSON.stringify(moment().year());
      this.weeklyDate = moment(year)
        .add(this.weekSelectedNumber, "weeks")
        .format("DD MMM yyyy");
    },
    setTheWeekNumber(date) {
      // const now = moment().format("MM-DD-YYYY");
      this.weekSelectedNumber = moment(date).isoWeek();
      this.setMonToSundayWeekDates();
      // this.setCalendarDate();
      this.despachTheWeekActionSetLocalStorage();
    },
    setSelectedDate() {
      this.weeklyDate = moment().format("YYYY-MM-DD");
      this.setTheWeekNumber(this.weeklyDate);
    },
    checkIfWeekNumberHasBeenSet() {
      if (this.getWeekNumber !== null && this.getWeekNumber !== "") {
        this.weekSelectedNumber = this.getWeekNumber;
        this.setCalendarDate();
        this.setMonToSundayWeekDates();
        this.despachTheWeekActionSetLocalStorage();
      } else {
        this.checkIfWeekNumberHasBeenSetInLocalStorage();
      }
    },
    despachTheCalendarActionSetLocalStorage() {
      const weeklyDate = this.weeklyDate;
      localStorage.setItem("calendarDate", this.weeklyDate);
      this.$store.dispatch(POPULATE_SELECTED_CALENDAR_DATE, this.weeklyDate);
      this.$emit("calendarDateChanged", { weeklyDate });
    },
    checkIfWeekNumberHasBeenSetInLocalStorage() {
      const weekNumber = localStorage.getItem("weekNumber");
      if (weekNumber !== null && weekNumber !== "") {
        this.weekSelectedNumber = JSON.parse(weekNumber);
        this.setMonToSundayWeekDates();
        this.despachTheWeekActionSetLocalStorage();
      } else {
        this.setSelectedDate();
      }
    },
    despachTheWeekActionSetLocalStorage() {
      const weekSelectedNumber = this.weekSelectedNumber;
      this.$store.dispatch(
        POPULATE_WEEK_SELECTED_NUMBER,
        this.weekSelectedNumber,
      );
      localStorage.setItem("weekNumber", weekSelectedNumber);
      this.$emit("weekSelectedChanged", { weekSelectedNumber });
    },
    setCoachesUsersData(id) {
      this.$store.dispatch(
        POPULATE_COACHES_USER_DATA,
        JSON.parse(localStorage.getItem("coachesUsersData")),
      );
      this.$emit("getAllUsersForThisAdmin");
      this.setSelectedTrainingPlanUser(id);
    },
    changeDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    dayMonthYear(date) {
      return moment(date).format("D MMM YYYY");
    },
  },
};
</script>
<style scoped>
img#small_shirt {
  width: 2.5rem;
}

.playing-extra-team .remove-extra-team {
  margin-left: 6px;
  color: #e53c3c;
  font-weight: 700;
  text-decoration: none;
}

.playing-extra-team .remove-extra-team:hover {
  opacity: 0.7;
}

.add-extra-team select {
  padding: 2px 6px;
  border: 1px solid #c3cdd5;
  border-radius: 6px;
  max-width: 14rem;
}

.header-phase-pill {
  margin-bottom: 8px;
}
</style>
